import { render } from "./PartnerManageCreateForm.vue?vue&type=template&id=cd00cf76&lang=true"
import script from "./PartnerManageCreateForm.vue?vue&type=script&lang=js"
export * from "./PartnerManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__